import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Titles from "../../components/Titles/Titles";
import Contact from "../../components/Contact/Contact";

const ContactPage = () => {
  return (
    <Container className="containerPadding100">
      <Row>
        <Col md={6} className="colContact">
          <div className="containerFormulaireHome">
            <Titles
              title={"Contact"}
              color={"white"}
              margin="0 0 60px 0"
            />
            <div className="containerAdresseHome">
              <p>7 B avenue de l'abbé Guichard</p>
              <p>17340 Chatelaillon-Plage</p>
              <br />
              <p>TEL: 06 11 83 00 49</p>
              <p>
                N° SIRET: 452 075 088 00040 Code APE : 9001 Z
              </p>
            </div>
            <Contact />
          </div>
        </Col>
        <Col md={6} className="map">
          <div className="mapouter">
            <div className="gmap_canvas">
              <iframe
                title="map"
                width="100%"
                height="460"
                id="gmap_canvas"
                src={`https://maps.google.com/maps?q=7%20bis%20rue%20de%20l'abbes%20guichard%2017340%20chatelaillon-plage&t=&z=15&ie=UTF8&iwloc=&output=embed`}
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ContactPage;
